import React, { useState, useEffect } from "react";
import Table from "../../Tables/PjpReportTable";
import { Button, getTabScrollButtonUtilityClass } from "@mui/material";
import { CSVLink } from "react-csv";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  TextField,
  FormControl,
  MenuItem,
  Select,
  Box,
  CircularProgress,
} from "@mui/material";
import moment from "moment";

// Css
import styles from "./MasterDashboard.module.css";
import { axios } from "setups/axios";

const Months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

let currentMonth = new Date().getMonth();

const MasterDashboard = () => {
  //? useState
  const [Loading, setLoading] = useState(true);
  const [Data, setData] = useState([]);
  const [Aos, setAos] = useState([]);
  const [Values, setValues] = useState({
    startDate: "",
    endDate: "",
    month: Months[currentMonth],
    AO_id: "",
  });

  //? destructuring
  const { month, startDate, endDate, AO_id } = Values;

  const getPjpReport = () => {
    axios()({
      url: `/api/v1/get/pjp/report?month=${
        month ? month : Months[currentMonth]
      }&startDate=${
        startDate ? startDate : moment().startOf("month").month(month).toDate()
      }&endDate=${
        endDate ? endDate : moment().endOf("month").month(month).toDate()
      }&_id=${AO_id}`,
      method: "get",
    })
      .then((data) => {
        console.log("data length", data.data.data.result.length);
        console.log("data", data.data.data.result);

        setData(data.data.data.result);

        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAllAOs = () => {
    axios()({
      url: `/api/v1/get/all/aos`,
      method: "get",
    })
      .then((data) => {
        console.log("AO's DATA", data);
        setAos(data.data.data.result);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    setLoading(true);
    getAllAOs();
    getPjpReport();
  }, [month, startDate, endDate, AO_id]);

  const headers = [
    { label: "SO ID", key: "_id" },
    { label: "PJP Count", key: "count" },
  ];

  const csvReport = {
    data: Data,
    headers: headers,
    filename: "PjpReport.csv",
  };

  //? monthHandler
  const monthHandler = (e) => {
    setValues({ ...Values, month: e.target.value });
  };

  //? dateHandler
  const dateHandler = (name) => (e) => {
    console.log("e", e);
    console.log("using moment", new Date(e).toISOString());
    setValues({ ...Values, [name]: new Date(e).toISOString() });
  };

  const selectAoHandler = (e) => {
    setValues({ ...Values, AO_id: e.target.value });
  };

  console.log("Values", Values);
  console.log("AOs", Aos);
  console.log("Current Month", Months[currentMonth]);

  return (
    <div>
      <div className={styles.together}>
        <h1>PJP Report {Loading ? "(...)" : `(${Data.length})`}</h1>
        {Data.length > 0 ? (
          <Button className={styles.exportBtn} variant="contained">
            {Loading ? (
              "Loading..."
            ) : (
              <CSVLink {...csvReport} target="_blank">
                Download
              </CSVLink>
            )}
          </Button>
        ) : (
          <Button variant="contained" disabled>
            Download
          </Button>
        )}
      </div>

      <div className={styles.optionWrapper}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Start Date"
            name="startDate"
            value={
              startDate
                ? startDate
                : moment().startOf("month").month(month).toDate()
            }
            onChange={dateHandler("startDate")}
            minDate={moment().startOf("month").month(month).toDate()}
            maxDate={
              endDate
                ? moment(startDate).toDate()
                : moment().endOf("month").month(month).toDate()
            }
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="End Date"
            name="endDate"
            value={
              endDate ? endDate : moment().endOf("month").month(month).toDate()
            }
            onChange={dateHandler("endDate")}
            minDate={
              startDate
                ? moment(startDate).toDate()
                : moment().startOf("month").month(month).toDate()
            }
            maxDate={moment().endOf("month").month(month).toDate()}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>

        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <Select
            value={month ? month : Months[currentMonth]}
            onChange={monthHandler}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            {Months &&
              Months.map((mon, index) => {
                return (
                  <MenuItem key={index} value={mon}>
                    {mon}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <Select
            value={AO_id}
            onChange={selectAoHandler}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={""} selected>
              Select AO
            </MenuItem>
            {Aos &&
              Aos.map((ao, index) => {
                let { SAP_ID, _id } = ao;
                return (
                  <MenuItem key={index} value={_id}>
                    {SAP_ID ? SAP_ID : "N/A"}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </div>

      <br />
      <div className={styles.tableWrapper}>
        {Loading ? (
          <Box sx={{ display: "flex", margin: "auto" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table
            Loading={Loading}
            Columns={["SO ID", "Count"]}
            Rows={Data ? Data : []}
          />
        )}
      </div>
    </div>
  );
};

export default MasterDashboard;
